import React, { useEffect, useState } from 'react';

import { CustomAttributeData } from '../../../customAttributes/customAttributes';
import { PriceData } from '../../../fileFormats/catalog/catalog';

interface ComponentCustomOptionGroupExtensionProps {
  attribute: CustomAttributeData,
  value: string,
  quantity: number | undefined,
  onQuantityChanged: ((updatedQuantity: number) => void) | undefined,
  editable: boolean,
  priceCurrencySymbol: string,
  priceData: PriceData[] | undefined,
}

export function ComponentCustomOptionGroupExtension({
  attribute,
  value,
  quantity,
  onQuantityChanged,
  editable,
  priceCurrencySymbol,
  priceData,
}: ComponentCustomOptionGroupExtensionProps): JSX.Element {

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updatedQuantity = Math.max(0, parseInt(event.target.value, 10) || 0);
    if (onQuantityChanged !== undefined) {
      onQuantityChanged(updatedQuantity);
    }
  };

  const [globalShowPrices, setGlobalShowPrices] = useState<boolean>(false);

  useEffect(() => {
    const root = document.documentElement;
    const computedStyle = getComputedStyle(root);

    // Get the value of the CSS variable and interpret it
    const showPricesValue = computedStyle.getPropertyValue('--show-prices').trim();
    setGlobalShowPrices(showPricesValue === 'true');
  }, []);

  const isNullOption = value === 'false';
  const basePrice = value === 'false' ? 0 : CustomAttributeData.getAttributeValuePrice(attribute.key, value, attribute.basePrice, priceData);
  const priceTotal = quantity !== undefined ? basePrice * quantity : 0;
  const roundedPriceTotal = Math.round(priceTotal * 100) / 100;
  const priceWithCurrency = `${roundedPriceTotal.toFixed(2)} ${priceCurrencySymbol}`;
  // const priceWithCurrency = `${priceTotal} ${priceCurrencySymbol}`;
  const basePriceWithCurrency = `${basePrice} ${priceCurrencySymbol}`;

  // TODO PMC: Read from Redux Slice "config" the SHOW_PRICE and set accordingly
  const showPrice = globalShowPrices && basePrice > 0;

  return (
    <div
      className="col-4"
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'right',
      }}
    >
      <div
        className="attribute-value-medium row"
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'right',
          alignItems: 'center',
        }}
      >
        {(!isNullOption && showPrice) && (
          <div className="col-3" style={{ marginLeft: '10px', width: '70px', textAlign: 'center' }}>{basePriceWithCurrency}</div>
        )}
        {(!isNullOption && showPrice && attribute.hasQuantity) && (
          <div className="col-1" style={{ marginLeft: '10px' }}> x </div>
        )}
        {(!isNullOption && quantity !== undefined && attribute.hasQuantity) && (
          editable ? (
            <input
              className="col-5"
              type="number"
              value={quantity}
              min={0}
              step={1}
              onChange={handleQuantityChange}
              style={{
                marginLeft: '10px', width: '70px', textAlign: 'center',
              }}
            />
          ) : (
            <input
              className="col-5"
              type="number"
              value={quantity}
              disabled
              style={{ marginLeft: '10px', width: '70px', background: '#e9ecef' }}
            />
          )
        )}
        {(!isNullOption && showPrice && attribute.hasQuantity) && (
          <div
            className="col-3"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ marginLeft: '10px' }}>=</div>
            <div style={{ marginLeft: '5px', width: '70px', textAlign: 'right' }}>{priceWithCurrency}</div>
          </div>
        )}
      </div>
    </div>
  );
}
